'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _PageContainer = require('./PageContainer');

var _PageContainer2 = _interopRequireDefault(_PageContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _PageContainer2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/PageContainer/index.js
// module id = 273
// module chunks = 11